import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Login from "./screens/Login";
import Layout from "./components/Layout";
import UserList from "./screens/UserList";
import RoleManager from "./screens/RoleManager";
import Transactions from "./screens/Transactions";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import SignUpLayOut from "./layouts/SignUpLayout";
import SignUp from "./view/signup";
import ForgotPassword from "./screens/ForgotPassword";
import WorkSpaceSetup from "./view/signup/WorkSpaceSetup";
import SplashScreen from "./components/SplashScreen";
import ProjectList from "./project-creation/ProjectList";
import CreateProject from "./project-creation/CreateProject";
import ProjectLayout from "layouts/ProjectLayOut";
import ProjectDetail from "view/project/ProjectDetail";
import AllIssue from "view/keyIssue/AllIssue";
import PendingApproval from "view/keyIssue/PendingApproval";
import SubmittedByMe from "view/keyIssue/SubmittedByMe";
import "react-datepicker/dist/react-datepicker.css";
import AllRisk from "view/keyRisk/AllRisk";
import RiskPendingApproval from "view/keyRisk/RiskPendingApproval";
import RiskSubmittedByMe from "view/keyRisk/RiskSubmittedByMe";
import VerifyIssue from "view/verifyIssue";
import WorkFlowSuccessed from "view/verifyIssue/WorkFlowSuccessed";
import UpdateWorkFlowIssue from "view/verifyIssue/UpdateWorkFlowIssue";
import projectkeyMenus from "components/menu-items";
import projectMenus from "components/menu-items";
import ProjectLanding from "view/projectLanding";
import AllClearance from "view/keyClearance/AllClearance";
import ClearancePendingApproval from "view/keyClearance/ClearancePendingApproval";
import ClearanceSubmittedByMe from "view/keyClearance/ClearanceSubmittedByMe";
import AllSafety from "view/keySafety/AllSafety";
import SafetyPendingApproval from "view/keySafety/SafetyPendingApproval";
import SafetySubmittedByMe from "view/keySafety/SafetySubmittedByMe";
import AllChangeTracker from "view/keyChangeTracker/AllChangeTracker";
import ChangeTrackerPendingApproval from "view/keyChangeTracker/ChangeTrackerPendingApproval";
import ChangeTrackerSubmittedByMe from "view/keyChangeTracker/ChangeTrackerSubmittedByMe";
import AllClaims from "view/keyClaims/AllClaims";
import ClaimsPendingApproval from "view/keyClaims/ClaimsPendingApproval";
import ClaimsSubmittedByMe from "view/keyClaims/ClaimsSubmittedByMe";
import AllNcr from "view/keyNcr/AllNcr";
import NcrPendingApproval from "view/keyNcr/NcrPendingApproval";
import NcrSubmittedByMe from "view/keyNcr/NcrSubmittedByMe";
import UpdateNcrWorkFlowIssue from "view/verifyNcr/UpdateWorkFlowIssue";
import VerifyQuality from "view/verifyNcr";
import NcrWorkFlowSuccessed from "view/verifyNcr/WorkFlowSuccessed";
import AllPM from "view/keyP&M/AllPM";
import PMPendingApproval from "view/keyP&M/PMPendingApproval";
import PMSubmittedByMe from "view/keyP&M/PMSubmittedByMe";
import AllMilestone from "view/keyMilestone/AllMilestone";
import MilestonePendingApproval from "view/keyMilestone/MilestonePendingApproval";
import MilestoneSubmittedByMe from "view/keyMilestone/MilestoneSubmittedByMe";
import AllManpowerProductivity from "view/keyManpower&Productivity/AllManpowerProductivity";
import ManpowerProductivityPendingApproval from "view/keyManpower&Productivity/ManpowerProductivityPendingApproval";
import AllFilesList from "view/fileManagement/AllFilesList";
import FilesSubmittedByMe from "view/fileManagement/FileSubmittedByMe";
import FilesPendingApproval from "view/fileManagement/FilePendingApproval";
import SubmittedByMeManpower from "view/keyManpower&Productivity/SubmittedByMeManpower";
import ProgramDashboard from "view/programDashboard";
import AllIMages from "view/imageGallery/AllImages";
import AllNorms from "view/config&settings/norms/AllNorms";
import PendingForApprovalImages from "view/imageGallery/PendingForApprovalImages";
import SubmittedByMeImages from "view/imageGallery/SubmittedByMeImages";
import AllSettings from "view/config&settings/projectSettings/AllSettings";
import Allactivities from "view/engineering/Allactivities";
import AllDocuments from "view/engineering/AllDocuments";
import PendingApprovalDocuments from "view/engineering/PendingApprovalDocuments";
import SubmittedByMeDocuments from "view/engineering/SubmittedByMeDocuments";
import AllMonteCarloSimulation from "view/monteCarloSimulation/AllMonteCarloSimulation";
import AllBOQ from "view/keyBOQ/AllBOQ";
import BimViewer from "view/bim";
import Role from "./screens/Role";
import AllWorkFlowList from "view/config&settings/workflow/AllWorkFlowList";
import MyWork from "view/myWork";
import AllDataAlertManagement from "view/config&settings/dataAlertManagement/AllDataAlertManagement";
import DocumentDetail from "view/engineering/DocumentDetail";
import AllSchedule from "view/key-schedule/AllSchedule";
import QuantityList from "view/KeyDPR/quantity";
import PMList from "view/KeyDPR/p&m";
import FloatingButtonWithAssistantDialog from "components/Chatbot/FloatingButtonWithAssistantDialog";
import KeyIssueDetail from "view/keyIssue/KeyIssueDetail";
import QualityDetail from "view/keyNcr/QualityDetail";
import SafetyDetail from "view/keySafety/SafetyDetail";
import KeyClearanceDetail from "view/keyClearance/KeyClearanceDetail";
import KeyRiskDetail from "view/keyRisk/KeyRiskDetail";
import DPRPMList from "view/KeyDPR/p&m";
import ChangeOrderDetail from "view/keyChangeTracker/ChangeOrderDetail";
import ClaimsDetail from "view/keyClaims/ClaimsDetail";
import MilestoneDetail from "view/keyMilestone/MilestoneDetail";
import PMDetail from "view/keyP&M/PMDetail";
import PMDPRDetail from "view/KeyDPR/PMDprDetail";
import AssignPermission from "view/permission/AssignPermission";
import FeatureList from "view/faqs/FeatureList";
import DataSets from "view/faqs/DataSets";
import GuestGuard from "utilis/route-gurad/GuestGuard";
import AuthGuard from "utilis/route-gurad/AuthGuard";
import UnauthorizedPage from "view/errorPage/UnauthorizedPage";
import PermissionGuard from "utilis/route-gurad/PermissionGurad";
import { HELP_DATA_SETS_LIST_ACCESS, HELP_FEATURE_LIST_ACCESS, DATA_METRICS_ACCESS, WORKFLOW_ACCESS, NORMS_ACCESS, PROJECT_SETTING_ACCESS, DPR_PM_ACCESS, DPR_QUANTITY_ACCESS, IMAGE_GALLERY_ACCESS, QUALITY_ACCESS, SAFETY_ACCESS, KEY_CLEARANCE_ACCESS, KEY_ISSUE_ACCESS, RISK_ACCESS, CLAIM_ACCESS, USERS_ACCESS, BULK_USER_TRANSACTION_ACCESS, ROLE_ACCESS, FILE_ACCESS, SCHEDULE_ACCESS, MILESTONE_ACCESS, ENGINEERING_ACCESS, PM_ACCESS, MONTE_CARLO_SIMULATION_ACCESS, BIM_VIEWER_ACCESS, BOQ_ACCESS, CHANGE_ORDER_ACCESS } from "config";
import { MANPOWER_ACCESS } from "config";
import { PERMISSION_ACCESS } from "config";
import DprPmSubmittedBy from "view/KeyDPR/dprPmSubmittedBy";
import SubmittedBOQ from "view/keyBOQ/submittedBOQ";
import ReportGenerator from "view/reports/ReportGenerator";
import MyReport from "view/reports/MyReport";
import ProjectHome from "view/home";
import CreateNewDpr from "view/KeyDPR/AddDpr";
import PrivacyPolicy from "policyterm/PrivacyPolicy";
import TermsConditions from "policyterm/TermsConditions";
import QuantityDPR from "view/KeyDPR/QuantityDPR";
import ScheduleDPRDetail from "view/KeyDPR/ScheduleDPRDetail";
import SubmittedByMeScheduleDPR from "view/KeyDPR/SubmittedByMeScheduleDPR";
import ConsentNotice from "policyterm/ConsentNotice";
import AuthCallback from "AuthCallback";


const theme = createTheme({
  typography: {
    pxToRem: (value) => `${value / 16}rem`,
  },
});

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  // const userInfo = useGetUserInfoQuery();

  const hideChatbot =
    path === "/" ||
    path === "/login" ||
    path === "/forgotPassword" ||
    path === "/worksetup" ||
    path === "/issue/response" ||
    path === "/ncr/response" ||
    path === "/unauthorized" ||
    path === "/privacy-policy" ||
    path === "/terms-conditions" ||
    path.startsWith("/verify/issue/") ||
    path.startsWith("/verify/ncr/") ||
    path.startsWith("/set-up-workspace") ||
    path.startsWith("/project-home/project-home");





  // useEffect(() => {
  //   const user = JSON.parse(localStorage.getItem("user"));
  //   const token = localStorage.getItem("token");
  //   if (user && token) {
  //     if (location.pathname === "/login") {
  //       navigate("/user-management/user-list");
  //     }
  //   } else {
  //   }
  // }, [navigate, location.pathname]);

  return (
    <>
      <Routes>
        {/* <Route path="/" element={<Navigate to="/login" />} /> */}
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="" element={<SplashScreen />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />

        <Route path="/worksetup" element={<WorkSpaceSetup />} />
        <Route path="/verify/issue/:issueId" element={<VerifyIssue />} />
        <Route path="/verify/issue/:issueId/updateWorkFlow" element={<UpdateWorkFlowIssue />} />
        <Route path="/issue/response" element={<WorkFlowSuccessed />} />
        <Route path="/verify/ncr/:qualityId" element={<VerifyQuality />} />
        <Route path="/verify/ncr/:qualityId/updateWorkFlow" element={<UpdateNcrWorkFlowIssue />} />
        <Route path="/ncr/response" element={<NcrWorkFlowSuccessed />} />

        <Route path="set-up-workspace" element={<SignUpLayOut />}>
          <Route path="" element={<SignUp />} />
        </Route>
        <Route path="/login" element={
          <GuestGuard >
            <Login />
          </GuestGuard>
        } />
        <Route path="/forgotPassword" element={<ForgotPassword />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy pValue={{ py: 8, px: 4, bg: '#f9f9f9' }} />} />
        <Route path="/terms-conditions" element={<TermsConditions pValue={{ py: 8, px: 4, bg: '#f9f9f9' }} />} />
        <Route path="/consent-notice" element={<ConsentNotice pValue={{ py: 8, px: 4, bg: '#f9f9f9' }} />} />

        <Route path="/:menu/*" element={<AuthGuard> <Layout /> </AuthGuard>}>
          <Route path="user-list" element={<UserList />} />
          <Route path="role-manager" element={<RoleManager />} />
          <Route path="transactions" element={<Transactions />} />
          <Route path="project-creation/project-list" element={<ProjectList />} />
          <Route path="program-dashboard" element={<ProgramDashboard />} />
          <Route path="portfolio-dashboard" element={<ProjectHome />}></Route>
        </Route>
        {/* <Route path="/projects/project-creation/project-list" element={<ProjectList />} /> */}
        <Route path="/projects/project-creation/addproject" element={<AuthGuard> <CreateProject /> </AuthGuard>} />

        <Route path="projects/:projectId/" element={<AuthGuard> <ProjectLayout leftMenuData={projectMenus?.keymenus} /> </AuthGuard>}>
          <Route index element={<ProjectDetail />} />
          <Route path="new_dpr/create-new-dpr" element={<CreateNewDpr />} />

          <Route path="dpr_pmList/PM_list" element={<PermissionGuard permission={DPR_PM_ACCESS}><DPRPMList /></PermissionGuard>} />
          <Route path="dpr/Quantity_list" element={<PermissionGuard permission={DPR_QUANTITY_ACCESS}><QuantityDPR /></PermissionGuard>} />
          <Route path="dpr/Quantity_list_submitted_by_me" element={<PermissionGuard permission={DPR_QUANTITY_ACCESS}><SubmittedByMeScheduleDPR /></PermissionGuard>} />
          <Route path="quantitydpr-detail/:id/:assignee/:isEditable" element={<ScheduleDPRDetail />} />

          <Route path="dpr_pmList/dprPm-submitted-by-me" element={<DprPmSubmittedBy />} />
          <Route path="key-issues/all-issue" element={<PermissionGuard permission={KEY_ISSUE_ACCESS}><AllIssue /></PermissionGuard>} />
          <Route path="key-issues/pending-approval" element={<PendingApproval />} />
          <Route path="key-issues/submitted-by-me" element={<SubmittedByMe />} />
          <Route path="issue-detail/:issueId/:assignee/:isEditable" element={<KeyIssueDetail />} />

          <Route path="key-risk/all-risk" element={<PermissionGuard permission={RISK_ACCESS}><AllRisk /></PermissionGuard>} />
          <Route path="key-risk/pending-approval-risk" element={<RiskPendingApproval />} />
          <Route path="key-risk/risk-submitted-by-me" element={<RiskSubmittedByMe />} />
          <Route path="risk-detail/:riskId/:assignee/:isEditable" element={<KeyRiskDetail />} />

          <Route path="user/list" element={<PermissionGuard permission={USERS_ACCESS}><UserList /> </PermissionGuard>} />
          <Route path="user/bulk-transactions" element={<PermissionGuard permission={BULK_USER_TRANSACTION_ACCESS}><Transactions /> </PermissionGuard>} />
          <Route path="user/assign-permission" element={<PermissionGuard permission={PERMISSION_ACCESS}><AssignPermission /></PermissionGuard>} />
          <Route path="user/role" element={<PermissionGuard permission={ROLE_ACCESS}><Role /></PermissionGuard>} />

          <Route path="my-work" element={<MyWork />} />

          <Route path="key-clearance/all-clearance" element={<PermissionGuard permission={KEY_CLEARANCE_ACCESS}><AllClearance /></PermissionGuard>} />
          <Route path="key-clearance/pending-approval-clearance" element={<ClearancePendingApproval />} />
          <Route path="key-clearance/clearance-submitted-by-me" element={<ClearanceSubmittedByMe />} />
          <Route path="clearance-detail/:clearanceId/:assignee/:isEditable" element={<KeyClearanceDetail />} />

          <Route path="key-safety/all-safety" element={<PermissionGuard permission={SAFETY_ACCESS}><AllSafety /></PermissionGuard>} />
          <Route path="key-safety/pending-approval-safety" element={<SafetyPendingApproval />} />
          <Route path="key-safety/safety-submitted-by-me" element={<SafetySubmittedByMe />} />
          <Route path="safety-detail/:safetyId/:assignee/:isEditable" element={<SafetyDetail />} />

          <Route path="key-change-tracker/all-change-tracker" element={<PermissionGuard permission={CHANGE_ORDER_ACCESS}><AllChangeTracker /></PermissionGuard>} />
          <Route path="key-change-tracker/pending-approval-change-tracker" element={<ChangeTrackerPendingApproval />} />
          <Route path="key-change-tracker/change-tracker-submitted-by-me" element={<ChangeTrackerSubmittedByMe />} />
          <Route path="change-detail/:id/:assignee/:isEditable" element={<ChangeOrderDetail />} />

          <Route path="key-claims/all-claims" element={<PermissionGuard permission={CLAIM_ACCESS}><AllClaims /></PermissionGuard>} />
          <Route path="key-claims/pending-approval-claims" element={<ClaimsPendingApproval />} />
          <Route path="key-claims/claims-submitted-by-me" element={<ClaimsSubmittedByMe />} />
          <Route path="claim-detail/:id/:assignee/:isEditable" element={<ClaimsDetail />} />

          <Route path="key-quality/all-quality" element={<PermissionGuard permission={QUALITY_ACCESS}><AllNcr /></PermissionGuard>} />
          <Route path="key-quality/pending-approval-quality" element={<NcrPendingApproval />} />
          <Route path="key-quality/quality-submitted-by-me" element={<NcrSubmittedByMe />} />
          <Route path="ncr-detail/:qualityId/:assignee/:isEditable" element={<QualityDetail />} />

          <Route path="key-file/all-file" element={<PermissionGuard permission={FILE_ACCESS}><AllFilesList /></PermissionGuard>} />
          <Route path="key-file/pending-approval-file" element={<FilesPendingApproval />} />
          <Route path="key-file/file-submitted-by-me" element={<FilesSubmittedByMe />} />

          <Route path="key-p&m/all-p&m" element={<PermissionGuard permission={PM_ACCESS}><AllPM /></PermissionGuard>} />
          <Route path="key-p&m/pending-approval-p&m" element={<PMPendingApproval />} />
          <Route path="key-p&m/p&m-submitted-by-me" element={<PMSubmittedByMe />} />
          <Route path="p&m-detail/:pmId/:assignee/:isEditable" element={<PMDetail />} />
          <Route path="pmdpr-detail/:pmId/:assignee/:isEditable" element={<PMDPRDetail />} />

          <Route path="key-milestone/all-milestone" element={<PermissionGuard permission={MILESTONE_ACCESS}><AllMilestone /> </PermissionGuard>} />
          <Route path="key-milestone/pending-approval-milestone" element={<MilestonePendingApproval />} />
          <Route path="key-milestone/milestone-submitted-by-me" element={<MilestoneSubmittedByMe />} />
          <Route path="milestone-detail/:id/:assignee/:isEditable" element={<MilestoneDetail />} />

          <Route path="key-manpower/all-manpower" element={<PermissionGuard permission={MANPOWER_ACCESS}><AllManpowerProductivity /> </PermissionGuard>} />
          <Route path="key-manpower/pending-approval-manpower" element={<ManpowerProductivityPendingApproval />} />
          <Route path="key-manpower/submitted-by-me-manpower" element={<SubmittedByMeManpower />} />

          <Route path="norms/all-norms" element={<PermissionGuard permission={NORMS_ACCESS}><AllNorms /></PermissionGuard>} />
          <Route path="project-settings/all-settings" element={<PermissionGuard permission={PROJECT_SETTING_ACCESS}><AllSettings /></PermissionGuard>} />

          <Route path="image-gallery/all-images" element={<PermissionGuard permission={IMAGE_GALLERY_ACCESS}><AllIMages /></PermissionGuard>} />
          <Route path="image-gallery/pending-approval-images" element={<PendingForApprovalImages />} />
          <Route path="image-gallery/images-submitted-by-me" element={<SubmittedByMeImages />} />

          <Route path="engineering/all-activities" element={<PermissionGuard permission={ENGINEERING_ACCESS}><Allactivities /> </PermissionGuard>} />
          <Route path="documents/all-documents/:activityId" element={<AllDocuments />} />
          <Route path="document-detail/:documentId/:assignee/:isEditable" element={<DocumentDetail />} />
          <Route path="documents/pending-approval-documents/:activityId" element={<PendingApprovalDocuments />} />
          <Route path="documents/documents-submitted-by-me/:activityId" element={<SubmittedByMeDocuments />} />

          <Route path="monte-carlo-simulation/all-monte-carlo-simulation" element={<PermissionGuard permission={MONTE_CARLO_SIMULATION_ACCESS}><AllMonteCarloSimulation /></PermissionGuard>} />

          <Route path="key-BOQ/all-BOQ" element={<PermissionGuard permission={BOQ_ACCESS}><AllBOQ /></PermissionGuard>} />
          <Route path="key-BOQ/boqSubmitted" element={<PermissionGuard permission={BOQ_ACCESS}><SubmittedBOQ /></PermissionGuard>} />

          <Route path="bim-viewer/all-bim-viewer" element={<PermissionGuard permission={BIM_VIEWER_ACCESS}><BimViewer /></PermissionGuard>} />

          <Route path="workflow/all-workflow" element={<PermissionGuard permission={WORKFLOW_ACCESS}><AllWorkFlowList /></PermissionGuard>} />

          <Route path="data-alert-management/all-data-alert-management" element={<PermissionGuard permission={DATA_METRICS_ACCESS}><AllDataAlertManagement /> </PermissionGuard>} />

          <Route path="key-schedule/all-schedule" element={<PermissionGuard permission={SCHEDULE_ACCESS}><AllSchedule /></PermissionGuard>} />

          {/* Faqs */}

          <Route path="faq/feature-list" element={<PermissionGuard permission={HELP_FEATURE_LIST_ACCESS}><FeatureList /></PermissionGuard>} />
          <Route path="faq/data-sets" element={<PermissionGuard permission={HELP_DATA_SETS_LIST_ACCESS}><DataSets /></PermissionGuard>} />
          <Route path="report/report-generator" element={<ReportGenerator />} />
          <Route path="report/my-reports" element={<MyReport />} />

        </Route>
        {/* <Route path="projects/:projectId/" element={<ProjectLayout leftMenuData={projectMenus?.projectDashboardMenus} />}>
        <Route path='project-landing' element={<ProjectLanding />} />
      </Route> */}

      </Routes >
      {!hideChatbot && <FloatingButtonWithAssistantDialog />}

    </>
  );
};

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;